import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthorizationService } from '../services/authorization.service';
import { BrowserStorageService } from '../services/storage.service';
import { UserService } from '../services/user.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(
    private authService: AuthorizationService,
    private router: Router,
    private storageService: BrowserStorageService) { }

  private verifyLogin(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const isLogin = this.authService.isLogin();
    if (isLogin) {
      const urlPath = this.storageService.windowReference().location.pathname;
      const isAdminArea = urlPath.includes('administrator-panel') ? true : false;
      const isArrangerArea = (
        urlPath.includes('add-note') ||
        urlPath.includes('note-list') ||
        urlPath.includes('contracts') ||
        urlPath.includes('arranger-details')
      ) ? true : false;

      if (isArrangerArea) {
        if (this.storageService.get('_role') === 'arranger' || this.storageService.get('_role') === 'admin') {
          return true;
        } else {
          return this.router.navigate(['']);
        }
      }

      if (isAdminArea) {
        if (this.storageService.get('_role') === 'admin') {
          return true;
        } else {
          return this.router.navigate(['']);
        }
      }

      if (!isAdminArea && !isArrangerArea) {
        return true;
      }
    } else {
      return this.router.navigate(['']);
    }

  }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.verifyLogin();
  }

  canActivateChild(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.verifyLogin();
  }
}
